import styled, { AnyStyledComponent } from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint } from 'react-components'

import LoginIconLogo from '../../assets/images/sign-in.svg'
import LogoutIconLogo from '../../assets/images/sign-out.svg'

export const Container = styled.div`
    position: ${({ theme }) => theme.style.position.fixed};
    top: 0;
    left: 0;
    right: 0;
    background-color: ${({ theme }) => theme.colors.white};
    padding: 0.625rem 0.875rem 0.5625rem 0.625rem;
    box-shadow: 0 ${({ theme }) => `${theme.spacing.xxxSmall} ${theme.spacing.xxSmall}`} 0 #00000033;
    z-index: 1002;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 1.125rem 1.25rem 1.0625rem;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 0.875rem 1.25rem 0.875rem;
    }
`

export const ContentContainer = styled.div`
    width: inherit;
    display: ${({ theme }) => theme.style.display.flex};
    flex-direction: ${({ theme }) => theme.style.flexDirection.row};
    justify-content: ${({ theme }) => theme.style.justifyContent.spaceBetween};
    align-items: ${({ theme }) => theme.style.alignItems.center};

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        max-width: 1110px;
        margin: 0 auto;
    }
`

export const LeftContainer = styled.div`
    display: ${({ theme }) => theme.style.display.flex};
    flex-direction: ${({ theme }) => theme.style.flexDirection.row};

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        font-size: ${({ theme }) => theme.typography.font.size.medium};
    }
`

export const ImageContainer = styled.a`
    width: 5.75rem;
    height: 1.875rem;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        width: 7.625rem;
        height: 2.5rem;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        height: ${({ theme }) => theme.layout.medium};
        width: 7.625rem;
    }
`

export const Image = styled.img`
    width: ${({ theme }) => theme.layout.fill};
    height: ${({ theme }) => theme.layout.fill};
`

export const RightContainer = styled.div`
    display: ${({ theme }) => theme.style.display.flex};
    flex-direction: ${({ theme }) => theme.style.flexDirection.row};
    align-items: ${({ theme }) => theme.style.alignItems.center};
`

export const ButtonContainer = styled.div`
    display: ${({ theme }) => theme.style.display.flex};
    align-items: ${({ theme }) => theme.style.alignItems.center};
    font-family: ${({ theme }) => theme.typography.font.family.lato};
    justify-content: ${({ theme }) => theme.style.justifyContent.center};
`
export const HeaderSolidButtonContainer = styled(ButtonContainer)`
    margin: 0 1.125rem;
    font-size: ${({ theme }) => theme.typography.font.size.xSmall};

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        margin-right: 0;
    }
`

export const ButtonContentContainer = styled.div`
    padding: ${props => props.theme.spacing.xSmall} 0.625rem;
    font-size: 0.75rem;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        line-height: normal;
        padding: 0.625rem 1.25rem 0.5625rem;
        font-size: 1rem;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        text-align: ${({ theme }) => theme.style.textAlign.center};
        font-size: ${({ theme }) => theme.typography.font.size.medium};
    }
`

export const ButtonContainerDesktop = styled.div`
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        align-items: ${({ theme }) => theme.style.alignItems.center};
        margin-left: 1.125rem;
        margin-right: 0;
        font-size: ${({ theme }) => theme.typography.font.size.xSmall};
        font-family: ${({ theme }) => theme.typography.font.family.lato};
        display: ${({ theme }) => theme.style.display.flex};
    }
`

export const NavigationIconContainer = styled.div`
    font-family: ${({ theme }) => theme.typography.font.family.lato};
    font-size: ${({ theme }) => theme.typography.font.size.xSmall};
    font-weight: 300;
    cursor: pointer;
`

export const SidebarContentContainer = styled.div`
    display: ${({ theme }) => theme.style.display.flex};
    flex-direction: ${({ theme }) => theme.style.flexDirection.column};
    justify-content: ${({ theme }) => theme.style.justifyContent.spaceBetween};
    height: ${({ theme }) => theme.layout.fill};
`

export const LowerContentContainer = styled.div`
    padding-bottom: 0.625rem;
`

export const SidebarButtonContainer = styled(ButtonContainer)`
    padding: 0.625rem 1.25rem;
    text-align: ${({ theme }) => theme.style.textAlign.center};
    font-size: ${({ theme }) => theme.typography.font.size.medium};
`

export const SidebarLinkContainer = styled(SidebarButtonContainer)`
    padding: 0 1.25rem 0.625rem;
`

export const SidebarLink = styled.a`
    font-family: ${({ theme }) => theme.typography.font.family.lato};
    font-size: ${({ theme }) => theme.typography.font.size.medium};
    color: ${({ theme }) => theme.colors.tfwBlack87};
    text-decoration: underline;
`

export const LoginIcon = styled(LoginIconLogo as AnyStyledComponent)`
    width: 14px;
    height: 14px;
    margin-right: 0.375rem;
`
export const LogoutIcon = styled(LogoutIconLogo as AnyStyledComponent)`
    width: 14px;
    height: 14px;
    margin-right: 0.375rem;
`
export const LogInButtonContentContainer = styled(ButtonContainer)`
    padding: 0.5625rem 1.125rem;
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 0.5625rem 1.625rem;
        justify-content: ${({ theme }) => theme.style.justifyContent.center};
        font-size: ${({ theme }) => theme.typography.font.size.medium};
    }
`

export const SideBarLoginButton = ButtonContainer

export const LogOutButtonContentContainer = LogInButtonContentContainer

export const LogOutButtonContainer = styled.div`
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        align-items: ${({ theme }) => theme.style.alignItems.center};
        font-size: ${({ theme }) => theme.typography.font.size.xSmall};
        font-family: ${({ theme }) => theme.typography.font.family.lato};
        display: ${({ theme }) => theme.style.display.flex};
    }
`

export const LoginButtonContainer = ButtonContainer
